import React from 'react';
import { createRoot } from 'react-dom/client';
import { GasQueryProvider, GasToastProvider } from '../../shared/kit';
import App from './App';
import type { ConstrainedSearchInitData } from './types';
import './style.css';

const mountEl = document.getElementById('gas-location-constrained-search-app');

if (mountEl?.dataset.reactInit && mountEl.isConnected && !mountEl.dataset.gasReactMounted) {
    mountEl.dataset.gasReactMounted = '1';
    const initData = JSON.parse(mountEl.dataset.reactInit) as ConstrainedSearchInitData;
    createRoot(mountEl).render(
        <React.StrictMode>
            <GasQueryProvider>
                <GasToastProvider>
                    <App initData={initData} />
                </GasToastProvider>
            </GasQueryProvider>
        </React.StrictMode>,
    );
}
